import {useMemo} from 'react';
import {useAgentBuilderServerState} from '../AgentBuilder.state';
import {useEnrichAccounts} from '../../../../hooks/useEnrichAccounts';
import {useAgentFields} from '../helpers';
import {AiEnrichmentAccountFilter} from '../../../../shared/fields/enrichment';
import {useScoringInfo} from '../../../../hooks/api/scoringInfo';
import {ensure} from '../../../../shared/util';
import {aiEnrichmentFilterToAccountFilter} from '../../../../shared/filter/accountFilter';

export function useEnrichAccountsForAgent({
  accountFilter,
}: {
  accountFilter: AiEnrichmentAccountFilter | undefined;
}) {
  const {id: agentId} = useAgentBuilderServerState();
  const {primaryField} = useAgentFields(agentId);
  const {data: scoringInfo} = useScoringInfo();
  const scoringRunId = scoringInfo?.latestRefresh?.runId;

  const accountSelection = useMemo(() => {
    if (!accountFilter || !scoringRunId) {
      return;
    }

    return {
      name: 'query' as const,
      query: {
        runId: scoringRunId,
        filter: aiEnrichmentFilterToAccountFilter(accountFilter),
      },
    };
  }, [accountFilter, scoringRunId]);

  return useEnrichAccounts({
    accountSelection,
    fieldDefinitionId: ensure(primaryField).id,
    enrichmentMode: {type: 'new'},
  });
}
